import React from "react";
import { YhPageHeader } from "@src/components/YhPageHeader";
import { SearchTypeEnum, } from "@src/components/YhPageHeader/Types";
import { useMarketingListModel } from "../allMemberMarketingListModel";
import { projectProposalStatusList } from "../allMemberMarketingListTypes";



export function PageHeader() {
    const {
        searchParam,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useMarketingListModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户姓名",
            fieldName: "customerName",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: projectProposalStatusList || []
        },
    ]
    return (
        <YhPageHeader
            title="列表"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}